import React from 'react';
import { Link } from 'react-router-dom';
import { createForm, useForm } from 'effector-forms';
import { FormField, TextInput, toaster } from 'evergreen-ui';

import { styled } from 'linaria/react';
import surprise from 'src/assets/surprise.png';
import mail from 'src/assets/mail.png';
import key from 'src/assets/key.png';

import { history } from 'src/history';
import { routes } from 'src/routes';
import { createUserFx } from 'src/store/user.store';

import { AuthForm, AuthContainer, AuthFormTitle, AuthHint, AuthButton } from 'src/features/auth/ui/components';

const Surprise = styled.div`
	text-align: center;
   margin-bottom: 20px;

	img {
		max-width: 100px;
	}
`;
const Icon = styled.span`
	img {
		max-width: 16px;
    opacity: .3;
    margin-right: -28px;
    filter: invert(1);
	}
`;

export const registrationForm = createForm({
	fields: {
		first_name: { init: '' },
		last_name: { init: '' },
		email: { init: '' },
		password: { init: '' },
	},
});

export const RegistrationPage = () => {
	const form = useForm(registrationForm);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		await createUserFx(form.values);
		toaster.notify(`An email has been sent to you to verify your account`);
		history.push(routes.root.auth.login.path);
	};

	return (
		<AuthContainer>

			<AuthForm onSubmit={handleSubmit}>
				<Surprise>
					<img src={surprise} alt=""/>
				</Surprise>
				<AuthFormTitle>Sign up</AuthFormTitle>
				<FormField
					style={{ marginTop: 10 }}
                    className={'inputstyle-auth'}
				>
					<TextInput
						required
						width={'100%'}
						value={form.fields.first_name.value}
						placeholder={'First name'}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.first_name.onChange(e.target.value)}
                       
					/>
				</FormField>
				<FormField
					style={{ marginTop: 10 }}
                    className={'inputstyle-auth'}
				>
					<TextInput
						required
						width={'100%'}
						value={form.fields.last_name.value}
						placeholder={'Last name'}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.last_name.onChange(e.target.value)}
                        
					/>
				</FormField>
				<FormField
					style={{ marginTop: 10, marginLeft: 15, marginRight: -15 }}
					value={form.fields.email.value}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.email.onChange(e.target.value)}
                    className={'inputstyle-auth'}
				>
					<Icon>
						<img src={mail} alt=""/>
					</Icon>
					<TextInput required width={'100%'} type={'email'} placeholder={'E-mail'}/>
				</FormField>
				<FormField
					style={{ marginTop: 10, marginLeft: 15, marginRight: -15 }}
					value={form.fields.password.value}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.password.onChange(e.target.value)}
                    className={'inputstyle-auth'}
				>
					<Icon>
						<img src={key} alt=""/>
					</Icon>
					<TextInput required width={'100%'} type={'password'} placeholder={'Password'} />
				</FormField>
				<AuthButton>
					Continue
				</AuthButton>
				<AuthHint>
					Already have an account? <Link to={routes.root.auth.login.path}>Sign in here</Link>
				</AuthHint>
			</AuthForm>
		</AuthContainer>
	);
};
